import KendoScheduler from '../KendoScheduler'
import KendoSchedulerResource from '../KendoSchedulerResource'
import KendoSchedulerView from '../KendoSchedulerView'

let KendoSchedulerInstaller = class {
    static install(Vue) {
        Vue.component(KendoScheduler.name, KendoScheduler)
        Vue.component(KendoSchedulerResource.name, KendoSchedulerResource)
        Vue.component(KendoSchedulerView.name, KendoSchedulerView)
    }
}

export default KendoSchedulerInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoSchedulerInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/kendo-scheduler-installer/index.js